import { DataSourceItem, DefaultDataSourceContext } from "@cervval.js/common/src/forms/dataSource";
import { AbstractDtoDatasource } from "./abstractDtoCacheDataSource";

/**
 * Data source implementation for a dtoCacheRepository, using the dto id (more precisely using {@link DTOCacheRepositoryOptions#getId}) as value
 */
export class DtoCacheDataSourceFromId<ElementTypes, TypeName extends keyof ElementTypes, DataSourceContext = DefaultDataSourceContext<ElementTypes[TypeName]>> extends AbstractDtoDatasource<ElementTypes, TypeName, number, DataSourceContext> {

    /** Get id from DataSource item */
    public override getValueFromItem(dataSourceItem: DataSourceItem<ElementTypes[TypeName]>): number | undefined {
        return dataSourceItem?.item != null ? this._cache.getDTOCacheRepository(this._typeName).getId(dataSourceItem.item) : undefined;
    }

    /** Get a DataSource item from id */
    public override getItemFromValue(id: number): DataSourceItem<ElementTypes[TypeName]> | undefined {
        const item = this._cache.getDTOCacheRepository(this._typeName).findDTOById(id);
        return item != null ? { item } : undefined;
    }
}